import React from "react";
var __jsx = React.createElement;
import HeaderMultiLocation from './HeaderMultiLocation';
function HeaderMultiLocationAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(HeaderMultiLocation, {
    multiLocationMenuContainers: entry,
    themeName: data.themeName,
    isBlade: data.isBlade
  });
}
export default HeaderMultiLocationAdapter;